import { z } from 'zod';
import { uuid, isoTimestamp, syncColumns } from '../schemas/common.js';
/**
 * Row and protocol shapes for the Morse module (docs/MORSE.md §5). Same shape
 * as every module on the generic sync core: `household_id` derived server-side,
 * the module's own mutation union and pull response over its one table.
 */
export const MORSE_SYNC_TABLES = ['morse_letters'];
export const morseSyncTable = z.enum(MORSE_SYNC_TABLES);
export const morseLetterRow = syncColumns.extend({
    /** Derived from (learner, letter) — see `morseLetterId`. */
    id: uuid,
    letter: z.string().regex(/^[A-Z]$/),
    box: z.number().int().min(0).max(20),
    due_at: isoTimestamp.nullish(),
    correct: z.number().int().min(0),
    wrong: z.number().int().min(0),
    word_hits: z.number().int().min(0),
    introduced_at: isoTimestamp.nullish(),
    mastered_at: isoTimestamp.nullish(),
    mnemonic: z.string().max(300).nullish(),
    /** The learner. Progress is one person's own, never shared. */
    created_by: uuid.nullish(),
});
const mutationId = z.object({ id: uuid });
const morseUpsert = mutationId.extend({
    op: z.literal('upsert'),
    table: z.literal('morse_letters'),
    row: morseLetterRow,
});
const morseDelete = mutationId.extend({
    op: z.literal('delete'),
    table: morseSyncTable,
    row: z.object({ id: uuid, updated_at: isoTimestamp }),
});
export const morseMutation = z.union([morseUpsert, morseDelete]);
export const morsePushRequest = z.object({ mutations: z.array(morseMutation).max(500) });
export const morsePushResponse = z.object({
    applied: z.array(uuid),
    rejected: z.array(z.object({ id: uuid, code: z.string(), message: z.string() })),
    server_time: isoTimestamp,
});
export const morsePullResponse = z.object({
    server_time: isoTimestamp,
    changes: z.object({ morse_letters: z.array(z.record(z.unknown())) }),
    has_more: z.boolean(),
    cursor: z.string().optional(),
    full_resync: z.boolean().optional(),
});
//# sourceMappingURL=schemas.js.map